/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_Body_FatInputs */

const en_us2_search_field_body_fat = /** @type {(inputs: Search_Field_Body_FatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Body fat`)
};

const pt_br2_search_field_body_fat = /** @type {(inputs: Search_Field_Body_FatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentual de gordura`)
};

const es_419_search_field_body_fat = /** @type {(inputs: Search_Field_Body_FatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grasa corporal`)
};

const pt_pt2_search_field_body_fat = /** @type {(inputs: Search_Field_Body_FatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentagem de gordura`)
};

const fr_fr2_search_field_body_fat = /** @type {(inputs: Search_Field_Body_FatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masse grasse`)
};

const de_de2_search_field_body_fat = /** @type {(inputs: Search_Field_Body_FatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Körperfett`)
};

const it_it2_search_field_body_fat = /** @type {(inputs: Search_Field_Body_FatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grasso corporeo`)
};

/**
* | output |
* | --- |
* | "Body fat" |
*
* @param {Search_Field_Body_FatInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_body_fat = /** @type {((inputs?: Search_Field_Body_FatInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_Body_FatInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_body_fat(inputs)
	if (locale === "es-419") return es_419_search_field_body_fat(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_body_fat(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_body_fat(inputs)
	if (locale === "de-DE") return de_de2_search_field_body_fat(inputs)
	if (locale === "it-IT") return it_it2_search_field_body_fat(inputs)
	return en_us2_search_field_body_fat(inputs)
});
export { search_field_body_fat as "search.field_body_fat" }